<script>
    import { ME } from "../../../api/socket";

    export let number;

    let isSelectable = number === ME;
</script>

<div class="plate" class:selectable={isSelectable}><span>{number}</span></div>

<style>
    .plate {
        display: inline-block;
        outline: white 1px solid;
        border: #666666 1px solid;
        border-radius: 3px;
        background: white;
        padding: 1px 4px 2px 6px;
        line-height: 100%;
        letter-spacing: 1px;
    }

    .plate span {
        font-size: 11px;
        line-height: 100%;
        font-family:
            courier,
            courier new,
            monospace;
        letter-spacing: 1px;
    }

    .plate.selectable span {
        user-select: text;
        -webkit-user-select: text;
    }

    .plate span::selection {
        background: var(--window-title-background);
        color: white;
    }
</style>
